import React from 'react';
export function Footer() {
  return <footer className="border-t border-white/10 bg-black pt-16 pb-8" data-id="element-1">
      <div className="mx-auto max-w-7xl px-6 lg:px-8" data-id="element-2">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-4" data-id="element-3">
          {/* Company Info */}
          <div className="lg:col-span-2" data-id="element-4">
            <div className="flex items-center gap-2 text-xl font-bold text-white mb-4" data-id="element-5">
              <span data-id="element-6">AVL Group</span>
            </div>
            <p className="text-sm text-gray-400 mb-4" data-id="element-7">
              123 Innovation Drive, Suite 400
              <br data-id="element-8" />
              San Francisco, CA 94103
              <br data-id="element-9" />
              United States
            </p>
          </div>

          {/* Website Sections */}
          <div data-id="element-10">
            <h3 className="text-sm font-semibold text-white mb-4" data-id="element-11">Website</h3>
            <ul className="space-y-3 text-sm text-gray-400" data-id="element-12">
              <li data-id="element-13">
                <a href="#solutions" className="hover:text-white transition-colors" data-id="element-14">
                  Solutions
                </a>
              </li>
              <li data-id="element-15">
                <a href="#about" className="hover:text-white transition-colors" data-id="element-16">
                  About
                </a>
              </li>
              <li data-id="element-17">
                <a href="#contact" className="hover:text-white transition-colors" data-id="element-18">
                  Contact
                </a>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div data-id="element-19">
            <h3 className="text-sm font-semibold text-white mb-4" data-id="element-20">Legal</h3>
            <ul className="space-y-3 text-sm text-gray-400" data-id="element-21">
              <li data-id="element-22">
                <a href="#" className="hover:text-white transition-colors" data-id="element-23">
                  Terms of Service
                </a>
              </li>
              <li data-id="element-24">
                <a href="#" className="hover:text-white transition-colors" data-id="element-25">
                  Privacy Policy
                </a>
              </li>
              <li data-id="element-26">
                <a href="#" className="hover:text-white transition-colors" data-id="element-27">
                  Cookie Policy
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16 border-t border-white/5 pt-8" data-id="element-28">
          <p className="text-xs text-gray-500 text-center" data-id="element-29">
            &copy; {new Date().getFullYear()} AVL Group. All rights reserved.
          </p>
        </div>
      </div>
    </footer>;
}